// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseMobileAppFlavorConfigAreaRoutes = {
  route: '/mobile-app-flavor-config',
}

export const MobileAppFlavorConfigAreaRoutes = transformRoutes(
  BaseMobileAppFlavorConfigAreaRoutes,
)
